import React, { Fragment, useEffect, useState, useRef } from "react";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import { MaterialReactTable } from 'material-react-table'
import type { ColumnFiltersState, PaginationState } from '@tanstack/react-table';
import { PAGES } from '../../Constants/CommonConstants';
import { paginationQuery, handleSearch } from '../../utils/GlobalHelper';
import { getDate } from '../../utils/Helper';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { getDateFormatData } from "../../utils/Helper";
import { LinkButtons } from "../FieldComponets/LinkButtons";
import { DashboardRedirectionAction } from "../../Redux/Action/CommonAction";
import { ReviewDeleteAction, ReviewlistGetAction } from "../../Redux/Action/ReviewAction";
import { SalonGetAction } from "../../Redux/Action/SalonAction";
import { userPicUrl } from '../../utils/Helper';
import Swal from 'sweetalert2'
import { StorageConstant, VALIDATION_MESSAGE } from "../../Constants/Constants";

function ReviewRating() {
  const [data, setData] = useState<any>([]);

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [sorting, setSorting] = useState<any>(['DESC']);
  const reviewRatinglist = useSelector((state: any) => state.ReviewGetState);
  const reviewratingdelete = useSelector((state: any) => state.ReviewDeleteState);
  const salonList = useSelector((state: any) => state.SalonGetState?.data?.data?.rows ?? []);
  const DashboardRedirectionStatedata = useSelector((state: any) => state.DashboardRedirectionState)

  useEffect(() => {
    dispatch(SalonGetAction({
      page: 0,
      pageSize: 100,
      search: '',
      orderBy: { field: 'id' },
      orderDirection: 'ASC',
      columnFilters: [{ id: 'status', value: '1' }]
    }));
  }, []);

  const formRef = useRef<HTMLFormElement>(null);
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [openSerach, setOpenSerach] = useState(false)
  const [serachstatus, setSerachstatus] = useState<any>('')

  const handleFilterValue = (e: any) => {
    const { name, value } = e.target;
    setSerachstatus((prevStatus: any) => ({ ...prevStatus, [name]: value, }));
  };

  const resetSearchfilter = () => {
    setSerachstatus({
    salon: ""
  });
  }

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: PAGES?.pageIndex,
    pageSize: PAGES?.pageSize
  });
  const [searchValue, setSearchValue] = useState('');
  const [rowCount, setRowCount] = useState(0);
  // Table Coulmns
  useEffect(() => {
    const fetchData = async () => {
      if (!data?.length) {
        setLoading(true);
      } else {
        setIsRefetching(true);
      }
      try {
        const userStatus = DashboardRedirectionStatedata?.data?.salon_id;
 
        let query: any = paginationQuery(
          pagination.pageIndex,
          pagination.pageSize,
          sorting,
          searchValue,
          columnFilters
        );
        query.columnFilters.push({ id: "salon_id", value: userStatus })
        dispatch(DashboardRedirectionAction('RESET'));
        await dispatch(ReviewlistGetAction(query));

      } catch (error) {
        setIsError(true);
        return;
      }
      setIsError(false);
      setLoading(false);
      setIsRefetching(false);
    };
    fetchData();
  }, [
    columnFilters,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    reviewratingdelete?.status
  ]);
  useEffect(() => {
    setData(reviewRatinglist?.data?.data?.rows);
    setRowCount(reviewRatinglist?.data?.data?.count);
  }, [reviewRatinglist?.data , reviewratingdelete?.status]);

  const handledelete = async (e: any) => {
    Swal.fire({
        title: VALIDATION_MESSAGE?.ARE_YOU_SURE,
        text: VALIDATION_MESSAGE?.ARE_YOU_DELETE_ANY,
        icon: 'warning',
        confirmButtonColor: '#31CE36',
        cancelButtonColor: '#d33',
        showDenyButton: true,
        denyButtonText: 'No',
        confirmButtonText: 'Yes',
    }).then(async (result) => {
        if (result.isConfirmed) {
          const data ={
            delete_id:e?.id,
            service_id:e?.service_id,
            salon_id:e?.salon_id
          }
          dispatch(ReviewDeleteAction(data))
          setLoading(true)
        }
    });
}
  
  const columns: any = [
    {
      accessorKey: 'S.NO',
      header: 'S.NO',
      accessorFn: (row: Object, index: number) => {
        const currentPage = pagination.pageIndex + 1 || 1; 
        const itemsPerPage = pagination.pageSize || 10; 
        const startIndex = (currentPage - 1) * itemsPerPage;
        const serialNumber = startIndex + index + 1;
        return serialNumber;
      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
      size: 50,
    },
    {
      accessorKey: 'user_detail.profile_pic',
      header: 'User Image',
      accessorFn: (row: { user_detail: any; }) =><img src={userPicUrl(row?.user_detail?.profile_pic)} alt='image' width={50} height={50}/>,
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: 'user_detail.name',
      header: 'User Name',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'salon_detail.salon_name',
      header: 'Salon Name',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'service_detail.name',
      header: 'Service Name',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'rate',
      header: 'Rating',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'comments',
      header: 'Review',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'created_at',
      header: 'Created At',
      accessorFn: (row: { created_at: any; }) => getDate(row.created_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: 'updated_at',
      header: 'Updated At',
      accessorFn: (row: { updated_at: any; }) => getDate(row.updated_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
  
    {
      header: 'Action',
      size: 30,
      accessorFn: (row: { id: any; }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <span>
            <a className="btn btn-danger-delete text-white" onClick={()=>handledelete(row)} >
              <i className="fas fa-trash-alt" title="Delete"></i>
              </a>
            </span>
          </ul>
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
  ];


  const handeldate = (e: any) => {
    const formattedDate = moment(e).format('YYYY-MM-DD');
    setStartDate(formattedDate);
  }

  const handelEnddate = (e: any) => {
    const formattedDate = moment(e).format('YYYY-MM-DD');
    setEndDate(formattedDate)
  }
  const handleserach = (e: any) => {
    e.preventDefault()
    const columnFilters = [
      // { id: "start_date", value: startDate.trim() },
      // { id: "end_date", value: endDate.trim() },
      // { id: "search", value: serachstatus?.namesearch?.trim() },
      // { id: "category_id", value: serachstatus?.category },
      { id: "salon_id", value: serachstatus?.salon },
      { id: "status", value: serachstatus?.services }

    ]
    setColumnFilters(columnFilters)
    setOpenSerach(true)
  }

  return (
    <Fragment>
      {loading || reviewratingdelete?.loading ||reviewRatinglist?.loading ? <Spinner /> : ""}
      <PageLayout
        title="Review Rating Management"
        breadcrumbs={{
          secLast: { 'link': '/review-rating-list', 'name': 'Review Rating Management' },
        }}
        buttons={[
          { url: '/', className: 'btn btn-success', text: '+ Add Service', show: false }, // This button will be shown
        ]}
      >


        {
        <form ref={formRef} onSubmit={handleserach}>

          <div className='row gy-3 mt-3 mb-4'>
            {/* <div className="col-md-4 col-lg-4 col-xl-3">
              <label>Start date</label>
              <DatePicker className="form-control" placeholderText='MM/DD/YYYY' value={startDate ? getDateFormatData(startDate) : ''} onChange={(e) => handeldate(e)} onKeyDown={(e) => e.preventDefault()} />
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label>End date</label>
              <DatePicker className="form-control" placeholderText='MM/DD/YYYY' value={endDate ? getDateFormatData(endDate) : ''} onChange={(e) => handelEnddate(e)} minDate={new Date(startDate)} onKeyDown={(e) => e.preventDefault()} />
            </div> */}
            <div className="col-md-4 col-lg-4 col-xl-3">
              {/* <label>All Salon</label> */}
              <select className='form-select shadow-none' name="salon" id="salon" value={serachstatus?.salon} onChange={handleFilterValue}>
                <option value="">All Salon</option>
                {salonList && salonList.map((res: any, i: any) => (
                  <option value={res.id} key={i} >{res.salon_name}</option>
                ))}
              </select>
            </div>
            <div className="col-6">
                <button className='btn theme-bg text-white me-2'>Filter</button>
                <button className='btn btn-success' onClick={() => resetSearchfilter()} >Reset</button>
              </div>  
            {/* <div className="col-md-4 col-lg-4 col-xl-3">
              <label>Services Status</label>
              <select className='form-select shadow-none' name="services" id="cars" onChange={handleFilterValue}>
                <option value="">All services</option>
                <option value="1">Active  services</option>
                <option value="0">Deactive services</option>
              </select>
            </div> */}
            <div className="row gy-3">
              {/* <div className='col-md-6 col-lg-4 col-xl-3'>
                <div className="input-group w-100">
                  <div className="input-group">
                    <span className="input-group-text fa-solid fa-magnifying-glass " id="basic-addon1"> <i className="fas fa-search"></i></span>
                    <input type='text' id="saerchId" name="namesearch" className="form-control m-0" placeholder='Search by name' onChange={handleFilterValue} />
                  </div>
                </div>
              </div> */}

              
            </div>
          </div>
        </form> 
        }
        {
          data &&
          <MaterialReactTable

            columns={columns}
            data={data}
            enableGlobalFilter={false}

            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={isError ? { color: 'error', children: 'Error loading data', } : undefined}
            muiSearchTextFieldProps={{
              placeholder: 'Search from name',
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) => handleSearch(
              value,
              setIsError,
              setLoading,
              setIsRefetching,
              setSearchValue,
            )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        }
        <ToastDefault />
      </PageLayout>
    </Fragment>
  );
}


export default ReviewRating


